// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-btn-icon.upi {
    transform: translate(-71px, -1px);
}

.payment-btn-icon.emi {
    transform: translate(-291px, -1px);
}

.payment-btn-icon.emi-bajajf {
    transform: translate(-291px, -5px);
}

.payment-btn-icon.cards {
    transform: translate(-23px, -1px);
}

.payment-btn-icon.wallet {
    transform: translate(-48px, -1px);
}

.payment-btn-icon.native,
.payment-btn-icon.netbanking {
    transform: translate(1px, 0px);
}

.payment-btn-icon.cod {
    transform: translate(-96px, -1px);
}

.payment-btn-icon.ppcod {
    transform: translate(-192px, -1px);
}

.payment-btn-icon.snapmint {
    transform: translate(-168px, -1px);
}

.payment-btn-icon.credpay {
    transform: translate(-216px, -1px);
}

.payment-btn-icon.bharatxpay,
.payment-btn-icon.emi-zestmoney,
.payment-btn-icon.bnpl-tatapay,
.payment-btn-icon.bnpl {
    transform: translate(-119px, 0px);
}

.payment-btn-icon.arrow {
    transform: translate(-246px, -4px);
}

.payment-btn-icon.bnpl-lazypay {
    transform: translate(-264px, -1px);
}

.payment-btn-icon.bnpl-gk {
    transform: translate(-315px, -2px);
}

.payment-btn-icon.bnpl-simplpay {
    transform: translate(-333px, -2px);
}

.payment-btn-icon.simplpayin3 {
    transform: translate(-333px, -2px);
}`, "",{"version":3,"sources":["webpack://./src/library/components/payment-icon/payment-icon.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;;;IAII,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":[".payment-btn-icon.upi {\n    transform: translate(-71px, -1px);\n}\n\n.payment-btn-icon.emi {\n    transform: translate(-291px, -1px);\n}\n\n.payment-btn-icon.emi-bajajf {\n    transform: translate(-291px, -5px);\n}\n\n.payment-btn-icon.cards {\n    transform: translate(-23px, -1px);\n}\n\n.payment-btn-icon.wallet {\n    transform: translate(-48px, -1px);\n}\n\n.payment-btn-icon.native,\n.payment-btn-icon.netbanking {\n    transform: translate(1px, 0px);\n}\n\n.payment-btn-icon.cod {\n    transform: translate(-96px, -1px);\n}\n\n.payment-btn-icon.ppcod {\n    transform: translate(-192px, -1px);\n}\n\n.payment-btn-icon.snapmint {\n    transform: translate(-168px, -1px);\n}\n\n.payment-btn-icon.credpay {\n    transform: translate(-216px, -1px);\n}\n\n.payment-btn-icon.bharatxpay,\n.payment-btn-icon.emi-zestmoney,\n.payment-btn-icon.bnpl-tatapay,\n.payment-btn-icon.bnpl {\n    transform: translate(-119px, 0px);\n}\n\n.payment-btn-icon.arrow {\n    transform: translate(-246px, -4px);\n}\n\n.payment-btn-icon.bnpl-lazypay {\n    transform: translate(-264px, -1px);\n}\n\n.payment-btn-icon.bnpl-gk {\n    transform: translate(-315px, -2px);\n}\n\n.payment-btn-icon.bnpl-simplpay {\n    transform: translate(-333px, -2px);\n}\n\n.payment-btn-icon.simplpayin3 {\n    transform: translate(-333px, -2px);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
